const ReviewsDetails = () => {
  return (
    <div>
      <div className="mb-5 flex items-center gap-5">
        <span className="font-pop text-xl text-cardSecondaryColor">
          (33056101)
        </span>
        <span className="bg-redBorder px-[18px] py-1.5 font-pop text-[10px] font-medium text-white">
          Advert
        </span>
      </div>
      <div className="mb-3 font-pop text-sm">
        <span className="pr-8 font-bold text-darkGreen">Final Bid :</span>
        <span className="font-medium text-primary"> R550,560.00</span>
      </div>

      <div className="font-pop text-sm">
        <span className="pr-4 font-bold text-darkGreen">End Date/Time :</span>
        <span className="bg-paginateBgGray py-2 px-5 text-[10px] font-medium text-primary">
          {" "}
          Ended
        </span>
      </div>
    </div>
  );
};

export default ReviewsDetails;
